<mat-list [attr.aria-label]="'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.FUNCTIONS_DESCRIPTION' | translate">
  @for (form of forms().controls; track form; let i = $index) {
    <mat-list-item class="list-item" [class.invalid-form]="form.invalid">
      <div class="list-item-content">
        <div class="list-item-text">
          {{ form.controls.id.value }}
          @if (form.invalid) {
            <mat-icon class="invalid-icon" color="warning">error</mat-icon>
            <span class="error-text">{{ form.getFirstErrorMessageI18N() | translate }}</span>
          }
        </div>
        @if (!form.invalid && form.dirty) {
          <span class="unsaved-changes-text">
            {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
          </span>
        }
        <button mat-icon-button (click)="toolFormDisplay.emit(form)" class="icon-button">
          <mat-icon class="icon">
            @if (form.enabled) {
              edit
            } @else {
              visibility
            }
          </mat-icon>
        </button>
        @if (allowRemovingAnyTools() || form.enabled) {
          <button mat-icon-button class="icon-button" (click)="handleToolRemoved($event, i)">
            <mat-icon class="icon">clear</mat-icon>
          </button>
        }
      </div>
    </mat-list-item>
  }
</mat-list>
<div class="tools">
  @if (showAddButton()) {
    <button mat-button color="primary" (click)="handleToolAdd($event)">
      {{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.ADD_FUNCTION' | translate }}
    </button>
  }
</div>
